import { render, staticRenderFns } from "./ArchiveRequestCreateDialog.vue?vue&type=template&id=47f6ca47&"
import script from "./ArchiveRequestCreateDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveRequestCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports